import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        status: '',
        token: localStorage.getItem('token') || '',
        bands: [],
        venues: [],
        events: [],
    },
    mutations: {
        auth_request(state) {
            state.status = 'loading'
        },
        auth_success(state, token) {
            state.status = 'success'
            state.token = token
        },
        auth_error(state) {
            state.status = 'error'
        },
        logout(state) {
            state.status = ''
            state.token = ''
        },
        set_bands(state, bands){
            state.bands = bands
        },
        set_venues(state, venues){
            state.venues = venues
        },
        set_events(state, events){
            state.events = events
        }
    },
    actions: {
        login({ commit }, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request')
                axios({ url: Vue.prototype.$backend + '/api/login', data: user, method: 'POST' })
                    .then(resp => {
                        const token = resp.data.token
                        localStorage.setItem('token', token)
                        // Add the following line:
                        axios.defaults.headers.common['Authorization'] = token
                        commit('auth_success', token)
                        resolve(resp)
                    })
                    .catch(err => {
                        commit('auth_error')
                        localStorage.removeItem('token')
                        reject(err)
                    })
            })
        },
        refresh({ commit }) {
            return new Promise((resolve, reject) => {
                commit('auth_request')
                axios({ url: Vue.prototype.$backend + '/api/refresh', data: { "refreshToken": localStorage.getItem("token") }, method: 'POST' })
                    .then(resp => {
                        const token = resp.data.token
                        localStorage.setItem('token', token)
                        // Add the following line:
                        axios.defaults.headers.common['Authorization'] = token
                        commit('auth_success', token)
                        resolve(resp)
                    })
                    .catch(err => {
                        commit('auth_error')
                        localStorage.removeItem('token')
                        reject(err)
                    })
            })
        },
        logout({ commit }) {
            return new Promise((resolve) => {
                commit('logout')
                localStorage.removeItem('token')
                delete axios.defaults.headers.common['Authorization']
                resolve()
            })
        },
        getBands({commit}){
            return new Promise((resolve, reject) => {
                axios({ url: Vue.prototype.$backend + '/api/bands', method: 'GET' })
                    .then(resp => {
                        const bands = resp.data
                        commit('set_bands', bands)
                        resolve(resp)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        getVenues({commit}){
            return new Promise((resolve, reject) => {
                axios({ url: Vue.prototype.$backend + '/api/venues', method: 'GET' })
                    .then(resp => {
                        const venues = resp.data
                        commit('set_venues', venues)
                        resolve(resp)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        getEvents({commit}){
            return new Promise((resolve, reject) => {
                axios({ url: Vue.prototype.$backend + '/api/events', method: 'GET' })
                    .then(resp => {
                        const events = resp.data
                        commit('set_events', events)
                        resolve(resp)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        }

    },
    getters: {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
        bands: state => state.bands,
        venues: state => state.venues,
        events: state => state.events,
    }
})
